import { Link, useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { database } from "../services/firebase";
import { ref, get } from "firebase/database";

import Dashboard from "./Dashboard";
import DemoDashboard from "./DemoDashboard";
import Features from "../pages/Features";
import ImageSlider from "../components/ImageSlider";

import first from "./assets/Real Estate Website in Beige White Purple Style/Home.png";
import logo from "./assets/UPSC.png";

const features = [
  {
    title: "Premium Current Affairs",
    img: "https://cdn-icons-png.flaticon.com/512/2991/2991148.png",
    color: "card-blue"
  },
  {
    title: "Question Banks",
    img: "https://cdn-icons-png.flaticon.com/512/3135/3135755.png",
    color: "card-purple"
  },
  {
    title: "Premium Notes",
    img: "https://cdn-icons-png.flaticon.com/512/2921/2921222.png",
    color: "card-orange"
  },
  {
    title: "Mock Exams",
    img: "https://cdn-icons-png.flaticon.com/512/4315/4315445.png",
    color: "card-green"
  },
  {
    title: "UPSC Analysis",
    img: "https://cdn-icons-png.flaticon.com/512/4149/4149643.png",
    color: "card-red"
  },
  {
    title: "AI Coaching",
    img: "https://cdn-icons-png.flaticon.com/512/4712/4712109.png",
    color: "card-dark"
  }
];

const trustPoints = [
  "Structured UPSC preparation",
  "Premium notes and answer frameworks",
  "Weekly current affairs coverage",
  "Smart question practice with explanations"
];

const stats = [
  { number: "10K+", label: "Questions Covered" },
  { number: "500+", label: "Premium Notes & Topics" },
  { number: "7 Days", label: "Weekly Premium Access" },
  { number: "AI", label: "Guided Learning Support" }
];








const examTabs = [
  {
    id: "prelims",
    label: "Prelims",
    badge: "Screening Stage",
    intro:
      "The Preliminary Examination is the first filtering stage of UPSC. It is objective-type and mainly tests breadth, speed, elimination skill, and conceptual awareness.",
    rows: [
      { title: "Exam Stage", value: "Stage 1 of UPSC CSE" },
      { title: "Exam Type", value: "Objective / MCQ Based" },
      { title: "Total Papers", value: "2 Papers" },
      { title: "Paper 1", value: "General Studies (GS Paper I)" },
      { title: "Paper 2", value: "CSAT (GS Paper II)" },
      { title: "Duration", value: "2 Hours Each Paper" },
      { title: "Language", value: "English / Hindi (except language-specific parts)" },
      { title: "Marks", value: "GS I = 200, CSAT = 200" },
      { title: "Total Marks", value: "400 Marks" },
      { title: "Counted for Merit?", value: "Only GS Paper I counts for cut-off" },
      { title: "CSAT Rule", value: "Qualifying only (minimum 33%)" },
      { title: "Negative Marking", value: "Yes — 1/3rd marks deducted per wrong answer" },
      { title: "Question Pattern", value: "MCQ with 4 options" },
      { title: "Main Focus", value: "Current Affairs, Polity, History, Geography, Economy, Environment, Science, Aptitude" },
      { title: "Purpose", value: "Shortlisting for Mains" }
    ]
  },
  {
    id: "mains",
    label: "Mains",
    badge: "Written Stage",
    intro:
      "The Mains Examination is the core scoring stage. It tests depth, analysis, structure, articulation, constitutional understanding, and answer-writing maturity.",
    rows: [
      { title: "Exam Stage", value: "Stage 2 of UPSC CSE" },
      { title: "Exam Type", value: "Descriptive / Written" },
      { title: "Total Papers", value: "9 Papers" },
      { title: "Qualifying Papers", value: "Paper A (Indian Language), Paper B (English)" },
      { title: "Merit Papers", value: "Essay, GS1, GS2, GS3, GS4, Optional Paper 1, Optional Paper 2" },
      { title: "Duration", value: "3 Hours Each Paper" },
      { title: "Language", value: "English / Hindi / approved language options" },
      { title: "Essay", value: "250 Marks" },
      { title: "GS Paper 1", value: "250 Marks" },
      { title: "GS Paper 2", value: "250 Marks" },
      { title: "GS Paper 3", value: "250 Marks" },
      { title: "GS Paper 4", value: "250 Marks" },
      { title: "Optional Paper 1", value: "250 Marks" },
      { title: "Optional Paper 2", value: "250 Marks" },
      { title: "Merit Total", value: "1750 Marks" },
      { title: "Negative Marking", value: "No negative marking" },
      { title: "Question Pattern", value: "Descriptive answers, analytical writing, structured presentation" },
      { title: "Main Focus", value: "Depth, analysis, interlinking, answer writing, governance, ethics, optional mastery" },
      { title: "Purpose", value: "Merit ranking + Interview qualification" }
    ]
  },
  {
    id: "interview",
    label: "Interview",
    badge: "Personality Stage",
    intro:
      "The Personality Test is not a knowledge quiz. It evaluates judgment, administrative temperament, awareness, communication, ethics, and balanced thinking.",
    rows: [
      { title: "Exam Stage", value: "Final Stage of UPSC CSE" },
      { title: "Exam Type", value: "Personality Test / Board Interview" },
      { title: "Total Marks", value: "275 Marks" },
      { title: "Duration", value: "Usually 25–40 Minutes" },
      { title: "Language", value: "English / Hindi / chosen medium where applicable" },
      { title: "Negative Marking", value: "No" },
      { title: "Question Pattern", value: "Panel-based discussion and personality assessment" },
      { title: "Main Focus", value: "Judgment, awareness, ethics, clarity, temperament, DAF-based questions" },
      { title: "Purpose", value: "Final personality evaluation for service suitability" },
      { title: "Final Merit", value: "Mains (1750) + Interview (275) = 2025 Marks" }
    ]
  }
];




export default function Home() {


   
    
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [checkingPremium, setCheckingPremium] = useState(false);
  const [activeExamTab, setActiveExamTab] = useState("prelims");

  const handlePremiumRoute = async () => {
    if (checkingPremium) return;

    try {
      setCheckingPremium(true);

      if (!user) {
        navigate("/subscription");
        return;
      }

      const snap = await get(ref(database, `subscriptions/${user.uid}`));

      if (snap.exists()) {
        const data = snap.val();
        const expiry = new Date(data.expiryTimestamp);

        if (data.premium && expiry > new Date()) {
          navigate("/premium-current-affairs");
          return;
        }
      }

      navigate("/subscription");
    } catch (error) {
      console.error("Premium check failed:", error);
      navigate("/subscription");
    } finally {
      setCheckingPremium(false);
    }
  };

  return (
    <div
      className="home-wrapper"
      style={{
        background:
          "radial-gradient(circle at top left, rgba(56,189,248,0.10), transparent 25%), radial-gradient(circle at top right, rgba(34,197,94,0.10), transparent 24%), linear-gradient(135deg, #020617, #0f172a, #111827)",
        color: "#ffffff",
        overflow: "hidden"
      }}
    >
      {/* ================= HERO ================= */}
      <section className="py-5 py-lg-6 position-relative">
        <div className="container py-4 py-lg-5">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <div
                style={{
                  display: "inline-block",
                  padding: "10px 18px",
                  borderRadius: "999px",
                  background: "rgba(56,189,248,0.10)",
                  border: "1px solid rgba(56,189,248,0.20)",
                  color: "#7dd3fc",
                  fontWeight: 800,
                  fontSize: "13px",
                  letterSpacing: "1px",
                  marginBottom: "22px"
                }}
              >
                UPSC TITAN SCORE • PREMIUM UPSC PREPARATION
              </div>

              <h1
                className="fw-bold"
                style={{
                  fontSize: "clamp(2.3rem, 6vw, 4.3rem)",
                  lineHeight: "1.12",
                  fontWeight: 900,
                  marginBottom: "20px"
                }}
              >
                Crack UPSC With
                <span
                  style={{
                    display: "block",
                    background: "linear-gradient(90deg, #38bdf8, #22c55e, #ffffff)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent"
                  }}
                >
                  AI Powered Learning
                </span>
              </h1>

              <p
                style={{
                  color: "#cbd5e1",
                  fontSize: "1.08rem",
                  lineHeight: "1.9",
                  maxWidth: "620px",
                  marginBottom: "28px"
                }}
              >
                UPSC Titan Score helps serious aspirants prepare with structured
                premium content, exam-focused question banks, answer writing support,
                weekly current affairs and modern smart learning tools.
              </p>

              <div className="d-flex flex-wrap gap-3 mb-4">
                <button
                  onClick={handlePremiumRoute}
                  className="btn btn-lg"
                  style={{
                    background: "linear-gradient(135deg, #22c55e, #16a34a)",
                    color: "#fff",
                    border: "none",
                    borderRadius: "18px",
                    padding: "14px 28px",
                    fontWeight: 800,
                    boxShadow: "0 14px 34px rgba(34,197,94,0.30)"
                  }}
                >
                  {checkingPremium ? "Checking..." : "Start Premium"}
                </button>

                <Link
                  to="/register"
                  className="btn btn-lg"
                  style={{
                    background: "rgba(255,255,255,0.05)",
                    color: "#f8fafc",
                    border: "1px solid rgba(255,255,255,0.12)",
                    borderRadius: "18px",
                    padding: "14px 28px",
                    fontWeight: 800,
                    backdropFilter: "blur(10px)"
                  }}
                >
                  Create Free Account
                </Link>
              </div>

              <div className="row g-3 mt-2">
                {trustPoints.map((item, index) => (
                  <div key={index} className="col-12 col-sm-6">
                    <div
                      style={{
                        padding: "14px 16px",
                        borderRadius: "18px",
                        background: "rgba(255,255,255,0.04)",
                        border: "1px solid rgba(255,255,255,0.08)",
                        color: "#e2e8f0",
                        fontWeight: 600,
                        fontSize: "0.95rem"
                      }}
                    >
                      ✅ {item}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-lg-6 text-center">
              <div
                style={{
                  position: "relative",
                  maxWidth: "520px",
                  margin: "0 auto"
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    inset: "10% 10% auto 10%",
                    height: "80%",
                    background: "radial-gradient(circle, rgba(34,197,94,0.22), transparent 60%)",
                    filter: "blur(50px)",
                    zIndex: 0
                  }}
                />

                <div
                  style={{
                    position: "relative",
                    zIndex: 2,
                    padding: "26px",
                    borderRadius: "34px",
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.10)",
                    backdropFilter: "blur(16px)",
                    boxShadow: "0 30px 90px rgba(0,0,0,0.35)"
                  }}
                >
                  <img
                    className="img-fluid"
                    src={logo}
                    alt="UPSC Titan Score premium learning platform"
                    style={{
                      maxHeight: "420px",
                      objectFit: "contain",
                      filter: "drop-shadow(0 25px 60px rgba(0,0,0,0.35))"
                    }}
                  />
                </div>

                <div
                  style={{
                    position: "absolute",
                    bottom: "-10px",
                    left: "20px",
                    padding: "14px 18px",
                    borderRadius: "20px",
                    background: "rgba(15,23,42,0.85)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    backdropFilter: "blur(16px)",
                    boxShadow: "0 16px 40px rgba(0,0,0,0.28)",
                    textAlign: "left",
                    zIndex: 3
                  }}
                >
                  <div style={{ color: "#22c55e", fontWeight: 800, fontSize: "13px" }}>
                    PREMIUM ACCESS
                  </div>
                  <div style={{ color: "#f8fafc", fontWeight: 700 }}>
                    Current Affairs + Notes + Questions
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= TRUST STATS ================= */}
      <section className="pb-5">
        <div className="container">
          <div className="row g-4">
            {stats.map((item, index) => (
              <div key={index} className="col-6 col-lg-3">
                <div
                  style={{
                    borderRadius: "28px",
                    padding: "28px 20px",
                    background: "rgba(255,255,255,0.04)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    backdropFilter: "blur(12px)",
                    textAlign: "center",
                    height: "100%"
                  }}
                >
                  <h3
                    style={{
                      fontSize: "2rem",
                      fontWeight: 900,
                      marginBottom: "8px",
                      color: "#f8fafc"
                    }}
                  >
                    {item.number}
                  </h3>
                  <p style={{ color: "#94a3b8", marginBottom: 0, fontWeight: 600 }}>
                    {item.label}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= FEATURE CARDS ================= */}
      <section className="container py-5">
        <div className="text-center mb-5">
          <div
            style={{
              display: "inline-block",
              padding: "8px 16px",
              borderRadius: "999px",
              background: "rgba(168,85,247,0.10)",
              border: "1px solid rgba(168,85,247,0.18)",
              color: "#d8b4fe",
              fontWeight: 800,
              fontSize: "13px",
              letterSpacing: "1px",
              marginBottom: "18px"
            }}
          >
            PREPARATION MODULES
          </div>

          <h2
            className="fw-bold"
            style={{
              fontSize: "clamp(1.9rem, 4vw, 3rem)",
              color: "#ffffff"
            }}
          >
            Premium UPSC Preparation Modules
          </h2>

          <p
            style={{
              color: "#94a3b8",
              maxWidth: "760px",
              margin: "16px auto 0",
              lineHeight: "1.9"
            }}
          >
            Everything a serious UPSC aspirant needs in one focused system —
            from current affairs and notes to practice, strategy and answer writing.
          </p>
        </div>

        <div className="row g-4">
          {features.map((item, index) => (
            <div className="col-12 col-md-6 col-xl-4" key={index}>
              <div
                style={{
                  borderRadius: "30px",
                  padding: "28px",
                  background:
                    "linear-gradient(145deg, rgba(15,23,42,0.94), rgba(17,24,39,0.90))",
                  border: "1px solid rgba(255,255,255,0.08)",
                  boxShadow: "0 20px 60px rgba(0,0,0,0.28)",
                  height: "100%",
                  transition: "all 0.25s ease"
                }}
              >
                <div
                  style={{
                    width: "72px",
                    height: "72px",
                    borderRadius: "22px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "rgba(56,189,248,0.10)",
                    border: "1px solid rgba(56,189,248,0.18)",
                    marginBottom: "22px"
                  }}
                >
                  <img
                    src={item.img}
                    alt={item.title}
                    style={{ width: "40px", height: "40px", objectFit: "contain" }}
                  />
                </div>

                <h5
                  style={{
                    color: "#f8fafc",
                    fontWeight: 800,
                    marginBottom: "12px",
                    fontSize: "1.15rem"
                  }}
                >
                  {item.title}
                </h5>

                <p
                  style={{
                    color: "#94a3b8",
                    lineHeight: "1.85",
                    marginBottom: 0
                  }}
                >
                  Structured UPSC focused preparation system designed for better
                  consistency, clarity and exam performance.
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <DemoDashboard />
      <Features />





            {/* ================= UPSC EXAM STRUCTURE ================= */}
      <section className="py-5">
        <div className="container">
          <div
            style={{
              borderRadius: "34px",
              padding: "40px 18px",
              background:
                "linear-gradient(145deg, rgba(2,6,23,0.96), rgba(15,23,42,0.94))",
              border: "1px solid rgba(255,255,255,0.08)",
              boxShadow: "0 24px 80px rgba(0,0,0,0.30)"
            }}
          >
            <div className="text-center mb-5">
              <div
                style={{
                  display: "inline-block",
                  padding: "8px 16px",
                  borderRadius: "999px",
                  background: "rgba(34,197,94,0.10)",
                  border: "1px solid rgba(34,197,94,0.18)",
                  color: "#bbf7d0",
                  fontWeight: 800,
                  fontSize: "13px",
                  letterSpacing: "1px",
                  marginBottom: "18px"
                }}
              >
                UPSC EXAM ROADMAP
              </div>

              <h2
                className="fw-bold"
                style={{
                  fontSize: "clamp(1.9rem, 4vw, 3rem)",
                  color: "#ffffff"
                }}
              >
                Understand UPSC Exam Structure Before You Start
              </h2>

              <p
                style={{
                  color: "#94a3b8",
                  maxWidth: "860px",
                  margin: "16px auto 0",
                  lineHeight: "1.9"
                }}
              >
                For first-time visitors, this gives a complete stage-by-stage
                breakdown of the UPSC Civil Services Examination — including
                papers, marks, duration, language, negative marking, and overall
                pattern in a simple premium format.
              </p>
            </div>

            {/* TAB BUTTONS */}
            <div className="d-flex flex-wrap justify-content-center gap-3 mb-4">
              {examTabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveExamTab(tab.id)}
                  className="btn"
                  style={{
                    borderRadius: "18px",
                    padding: "12px 20px",
                    fontWeight: 800,
                    fontSize: "0.95rem",
                    border:
                      activeExamTab === tab.id
                        ? "1px solid rgba(56,189,248,0.35)"
                        : "1px solid rgba(255,255,255,0.08)",
                    background:
                      activeExamTab === tab.id
                        ? "linear-gradient(135deg, rgba(56,189,248,0.20), rgba(34,197,94,0.16))"
                        : "rgba(255,255,255,0.04)",
                    color: "#f8fafc",
                    boxShadow:
                      activeExamTab === tab.id
                        ? "0 12px 30px rgba(56,189,248,0.14)"
                        : "none",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {/* ACTIVE TAB CONTENT */}
            {examTabs
              .filter((tab) => tab.id === activeExamTab)
              .map((tab) => (
                <div key={tab.id}>
                  <div
                    style={{
                      borderRadius: "26px",
                      padding: "24px",
                      background: "rgba(255,255,255,0.04)",
                      border: "1px solid rgba(255,255,255,0.08)",
                      marginBottom: "26px"
                    }}
                  >
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-3">
                      <div>
                        <div
                          style={{
                            display: "inline-block",
                            padding: "7px 14px",
                            borderRadius: "999px",
                            background: "rgba(56,189,248,0.10)",
                            border: "1px solid rgba(56,189,248,0.18)",
                            color: "#7dd3fc",
                            fontWeight: 800,
                            fontSize: "12px",
                            letterSpacing: "1px",
                            marginBottom: "12px"
                          }}
                        >
                          {tab.badge}
                        </div>

                        <h3
                          style={{
                            color: "#ffffff",
                            fontWeight: 900,
                            marginBottom: "10px"
                          }}
                        >
                          {tab.label} Stage Overview
                        </h3>
                      </div>

                      <div
                        style={{
                          padding: "12px 16px",
                          borderRadius: "18px",
                          background: "rgba(34,197,94,0.10)",
                          border: "1px solid rgba(34,197,94,0.18)",
                          color: "#dcfce7",
                          fontWeight: 800,
                          fontSize: "0.92rem"
                        }}
                      >
                        UPSC Civil Services Exam
                      </div>
                    </div>

                    <p
                      style={{
                        color: "#cbd5e1",
                        lineHeight: "1.95",
                        marginBottom: 0
                      }}
                    >
                      {tab.intro}
                    </p>
                  </div>

                  {/* DESKTOP TABLE */}
                  <div className="d-none d-md-block">
                    <div
                      style={{
                        borderRadius: "28px",
                        overflow: "hidden",
                        border: "1px solid rgba(255,255,255,0.08)",
                        background: "rgba(255,255,255,0.03)",
                        boxShadow: "0 18px 60px rgba(0,0,0,0.22)"
                      }}
                    >
                      <div className="table-responsive">
                        <table className="table align-middle mb-0">
                          <thead>
                            <tr
                              style={{
                                background:
                                  "linear-gradient(135deg, rgba(56,189,248,0.16), rgba(34,197,94,0.10))"
                              }}
                            >
                              <th
                                style={{
                                  color: "#000000",
                                  fontWeight: 800,
                                  padding: "18px 20px",
                                  borderBottom: "1px solid rgba(255,255,255,0.08)",
                                  minWidth: "220px"
                                }}
                              >
                                Exam Detail
                              </th>
                              <th
                                style={{
                                  color: "#000000",
                                  fontWeight: 800,
                                  padding: "18px 20px",
                                  borderBottom: "1px solid rgba(255,255,255,0.08)"
                                }}
                              >
                                Information
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {tab.rows.map((row, index) => (
                              <tr
                                key={index}
                                style={{
                                  borderBottom: "1px solid rgba(255,255,255,0.06)"
                                }}
                              >
                                <td
                                  style={{
                                    color: "#f8fafc",
                                    fontWeight: 700,
                                    padding: "18px 20px",
                                    background:
                                      index % 2 === 0
                                        ? "rgba(255,255,255,0.02)"
                                        : "rgba(255,255,255,0.01)"
                                  }}
                                >
                                  {row.title}
                                </td>
                                <td
                                  style={{
                                    color: "#cbd5e1",
                                    padding: "18px 20px",
                                    lineHeight: "1.8",
                                    background:
                                      index % 2 === 0
                                        ? "rgba(255,255,255,0.015)"
                                        : "rgba(255,255,255,0.008)"
                                  }}
                                >
                                  {row.value}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  {/* MOBILE CARD TABLE */}
                  <div className="d-md-none">
                    <div className="row g-3">
                      {tab.rows.map((row, index) => (
                        <div className="col-12" key={index}>
                          <div
                            style={{
                              borderRadius: "22px",
                              padding: "18px",
                              background: "rgba(255,255,255,0.04)",
                              border: "1px solid rgba(255,255,255,0.08)",
                              boxShadow: "0 12px 34px rgba(0,0,0,0.18)"
                            }}
                          >
                            <div
                              style={{
                                color: "#7dd3fc",
                                fontWeight: 800,
                                fontSize: "0.9rem",
                                marginBottom: "8px"
                              }}
                            >
                              {row.title}
                            </div>

                            <div
                              style={{
                                color: "#e2e8f0",
                                lineHeight: "1.85",
                                fontSize: "0.95rem"
                              }}
                            >
                              {row.value}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}

            {/* QUICK SUMMARY */}
            <div className="row g-4 mt-4">
              <div className="col-md-4">
                <div
                  style={{
                    borderRadius: "24px",
                    padding: "24px",
                    background: "rgba(255,255,255,0.04)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    height: "100%"
                  }}
                >
                  <div style={{ fontSize: "1.8rem", marginBottom: "12px" }}>⚡</div>
                  <h5 style={{ color: "#fafafa", fontWeight: 800 }}>
                    Prelims Strategy
                  </h5>
                  <p style={{ color: "#94a3b8", lineHeight: "1.85", marginBottom: 0 }}>
                    Focus on elimination, revision cycles, MCQ accuracy, current
                    affairs integration, and CSAT qualification safety.
                  </p>
                </div>
              </div>

              <div className="col-md-4">
                <div
                  style={{
                    borderRadius: "24px",
                    padding: "24px",
                    background: "rgba(255,255,255,0.04)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    height: "100%"
                  }}
                >
                  <div style={{ fontSize: "1.8rem", marginBottom: "12px" }}>📝</div>
                  <h5 style={{ color: "#ffffff", fontWeight: 800 }}>
                    Mains Strategy
                  </h5>
                  <p style={{ color: "#94a3b8", lineHeight: "1.85", marginBottom: 0 }}>
                    Build answer structure, content depth, interlinking ability,
                    examples, diagrams, and time-bound writing practice.
                  </p>
                </div>
              </div>

              <div className="col-md-4">
                <div
                  style={{
                    borderRadius: "24px",
                    padding: "24px",
                    background: "rgba(255,255,255,0.04)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    height: "100%"
                  }}
                >
                  <div style={{ fontSize: "1.8rem", marginBottom: "12px" }}>🎙️</div>
                  <h5 style={{ color: "#ffffff", fontWeight: 800 }}>
                    Interview Strategy
                  </h5>
                  <p style={{ color: "#94a3b8", lineHeight: "1.85", marginBottom: 0 }}>
                    Improve personality clarity, calm articulation, constitutional
                    balance, DAF awareness, and practical administrative thinking.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      

      {/* ================= WHY PLATFORM ================= */}
      <section className="py-5">
        <div className="container">
          <div
            style={{
              borderRadius: "34px",
              padding: "40px 28px",
              background:
                "linear-gradient(145deg, rgba(2,6,23,0.94), rgba(15,23,42,0.92))",
              border: "1px solid rgba(255,255,255,0.08)",
              boxShadow: "0 20px 70px rgba(0,0,0,0.30)"
            }}
          >
            <div className="text-center mb-5">
              <h2
                className="fw-bold"
                style={{ fontSize: "clamp(1.8rem, 4vw, 2.8rem)" }}
              >
                Why Aspirants Choose UPSC Titan Score
              </h2>
              <p
                style={{
                  color: "#94a3b8",
                  maxWidth: "760px",
                  margin: "14px auto 0",
                  lineHeight: "1.9"
                }}
              >
                Built for clarity, discipline and practical UPSC preparation —
                not just content overload.
              </p>
            </div>

            <div className="row g-4 text-center">
              <div className="col-md-4">
                <div style={whyCardStyle}>
                  <div style={whyIconStyle}>📚</div>
                  <h3 style={whyTitleStyle}>Exam-Focused Content</h3>
                  <p style={whyTextStyle}>
                    Topic-wise structured preparation designed for real UPSC needs.
                  </p>
                </div>
              </div>

              <div className="col-md-4">
                <div style={whyCardStyle}>
                  <div style={whyIconStyle}>🧠</div>
                  <h3 style={whyTitleStyle}>Smart Learning System</h3>
                  <p style={whyTextStyle}>
                    Practice, explanation, revision and guided learning in one flow.
                  </p>
                </div>
              </div>

              <div className="col-md-4">
                <div style={whyCardStyle}>
                  <div style={whyIconStyle}>🎯</div>
                  <h3 style={whyTitleStyle}>Affordable Premium Access</h3>
                  <p style={whyTextStyle}>
                    High-value UPSC preparation at a simple weekly subscription.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= CTA ================= */}
      <section className="py-5 text-center">
        <div className="container">
          <div
            style={{
              borderRadius: "36px",
              padding: "52px 28px",
              background:
                "linear-gradient(135deg, rgba(34,197,94,0.14), rgba(56,189,248,0.12), rgba(15,23,42,0.90))",
              border: "1px solid rgba(255,255,255,0.08)",
              boxShadow: "0 24px 80px rgba(0,0,0,0.30)"
            }}
          >
            <div
              style={{
                display: "inline-block",
                padding: "8px 16px",
                borderRadius: "999px",
                background: "rgba(34,197,94,0.12)",
                border: "1px solid rgba(34,197,94,0.18)",
                color: "#bbf7d0",
                fontWeight: 800,
                fontSize: "13px",
                letterSpacing: "1px",
                marginBottom: "18px"
              }}
            >
              START YOUR UPSC SYSTEM
            </div>

            <h2
              style={{
                fontSize: "clamp(2rem, 4vw, 3rem)",
                fontWeight: 900,
                color: "#ffffff",
                marginBottom: "16px"
              }}
            >
              Unlock Complete UPSC Preparation
            </h2>

            <p
              style={{
                color: "#cbd5e1",
                maxWidth: "760px",
                margin: "0 auto 28px",
                lineHeight: "1.9"
              }}
            >
              Access premium current affairs, question banks, notes, mock support
              and guided study resources with one weekly plan.
            </p>

            <button
              onClick={handlePremiumRoute}
              className="btn btn-lg"
              style={{
                background: "linear-gradient(135deg, #22c55e, #16a34a)",
                color: "#fff",
                border: "none",
                borderRadius: "18px",
                padding: "15px 30px",
                fontWeight: 800,
                boxShadow: "0 14px 34px rgba(34,197,94,0.30)"
              }}
            >
              {checkingPremium ? "Checking..." : "Get Premium Access"}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

const whyCardStyle = {
  borderRadius: "28px",
  padding: "28px",
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(255,255,255,0.08)",
  height: "100%"
};

const whyIconStyle = {
  width: "72px",
  height: "72px",
  borderRadius: "22px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 auto 18px",
  fontSize: "1.8rem",
  background: "rgba(56,189,248,0.10)",
  border: "1px solid rgba(56,189,248,0.18)"
};

const whyTitleStyle = {
  color: "#f8fafc",
  fontWeight: 800,
  fontSize: "1.18rem",
  marginBottom: "10px"
};

const whyTextStyle = {
  color: "#94a3b8",
  lineHeight: "1.85",
  marginBottom: 0
};